export default __webpack_public_path__ + "static/media/5.07f157c2.jpg";